// Module
var code = `<dice-person-avatar person="avatarController.person"></dice-person-avatar> `;
// Exports
module.exports = code;